import React from 'react';
import PropTypes from 'prop-types';
import MuiArrowBackIcon from '@mui/icons-material/ArrowBack';
import * as colors from '@constants/colors';

const ArrowBackIcon = ({ color, onClick, style }) => (
  <MuiArrowBackIcon
    color={color}
    onClick={onClick}
    onKeyDown={event => (event.key === 'Enter' || event.key === ' ') && (event.preventDefault() || onClick())}
    role="button"
    tabIndex={0}
    aria-label="back"
    // MUI's SvgIcon defaults to aria-hidden="true" unless overridden - left in place when
    // role/tabIndex were added here, so this was focusable but invisible to screen readers.
    aria-hidden={false}
    style={{
      alignItems: 'center',
      display: 'flex',
      flexGrow: 0,
      cursor: 'pointer',
      padding: '0.75rem',
      height: '1.5rem',
      width: '1.5rem',
      ...style
    }}
  />
);

ArrowBackIcon.propTypes = {
  color: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object
};

ArrowBackIcon.defaultProps = {
  color: colors.textColor
};

export default ArrowBackIcon;
